// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xQRu89sFBI9pqZ {
  border-radius: var(--ds-border-radius-200, 8px);
}
.xQRu89sFBI9pqZ:focus,
.xQRu89sFBI9pqZ:active,
.xQRu89sFBI9pqZ.XuUgcGp9OziMnJ {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .xQRu89sFBI9pqZ:focus,
.mac .xQRu89sFBI9pqZ:active,
.mac .xQRu89sFBI9pqZ.XuUgcGp9OziMnJ {
  outline-color: -webkit-focus-ring-color;
}
.xQRu89sFBI9pqZ:focus .mac.firefox,
.xQRu89sFBI9pqZ:active .mac.firefox,
.xQRu89sFBI9pqZ.XuUgcGp9OziMnJ .mac.firefox {
  outline-color: AccentColor;
}
.xQRu89sFBI9pqZ.A4czYNX58FcePQ {
  min-width: 120px;
  height: auto;
  margin: var(--ds-space-050, 4px);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createBoardTile": `xQRu89sFBI9pqZ`,
	"active": `XuUgcGp9OziMnJ`,
	"grid": `A4czYNX58FcePQ`
};
export default ___CSS_LOADER_EXPORT___;
